import React, { useState, Fragment } from 'react';
import { Plus, ArrowRight, Clock, CheckCircle, AlertCircle, X, UserPlus, Settings, MoreVertical, ChevronDown, Eye, BarChart, Search, Filter } from 'lucide-react';
import { DepartmentSelector } from './DepartmentSelector';
import { WorkflowCreationModal } from './WorkflowCreationModal';
import { WorkflowViewerModal } from './WorkflowViewerModal';
import { WorkflowAnalytics } from './WorkflowAnalytics';
export const WorkflowManagement = ({
  activeDepartment,
  setActiveDepartment
}) => {
  const [activeTab, setActiveTab] = useState('active');
  const [isWorkflowModalOpen, setIsWorkflowModalOpen] = useState(false);
  const [workflowToEdit, setWorkflowToEdit] = useState(null);
  const [localWorkflows, setLocalWorkflows] = useState(workflows);
  const [selectedWorkflow, setSelectedWorkflow] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // 'list' or 'analytics'
  const handleCreateWorkflow = () => {
    setWorkflowToEdit(null);
    setIsWorkflowModalOpen(true);
  };
  const handleEditWorkflow = workflow => {
    setWorkflowToEdit(workflow);
    setIsWorkflowModalOpen(true);
  };
  const handleCloseWorkflowModal = savedWorkflow => {
    if (savedWorkflow) {
      // If we're editing an existing workflow
      if (workflowToEdit) {
        setLocalWorkflows(localWorkflows.map(w => w.id === savedWorkflow.id ? savedWorkflow : w));
      } else {
        // If we're creating a new workflow
        setLocalWorkflows([...localWorkflows, savedWorkflow]);
      }
    }
    setIsWorkflowModalOpen(false);
    setWorkflowToEdit(null);
  };
  const handleViewWorkflow = workflow => {
    setSelectedWorkflow(workflow);
  };
  const handleCloseViewer = () => {
    setSelectedWorkflow(null);
  };
  const departments = ['General Manager Office', 'Finance Department', 'HR Department', 'IT Department', 'Legal Department', 'Audit Department'];
  return <div className="p-6" data-id="element-1593">
      <div className="flex justify-between items-center mb-6" data-id="element-1594">
        <div className="flex items-center space-x-4" data-id="element-1595">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-1596">Workflows</h1>
          <DepartmentSelector activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} data-id="element-1597" />
        </div>
        <div className="flex items-center space-x-3" data-id="element-1598">
          <div className="flex border border-gray-300 rounded-md overflow-hidden" data-id="element-1599">
            <button className={`px-3 py-2 flex items-center space-x-1 ${viewMode === 'list' ? 'bg-gray-100 text-gray-800' : 'bg-white text-gray-600'}`} onClick={() => setViewMode('list')} data-id="element-1600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1601">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-1602" />
              </svg>
              <span className="text-sm" data-id="element-1603">List</span>
            </button>
            <button className={`px-3 py-2 flex items-center space-x-1 ${viewMode === 'analytics' ? 'bg-gray-100 text-gray-800' : 'bg-white text-gray-600'}`} onClick={() => setViewMode('analytics')} data-id="element-1604">
              <BarChart className="h-5 w-5" data-id="element-1605" />
              <span className="text-sm" data-id="element-1606">Analytics</span>
            </button>
          </div>
          <button className="px-4 py-2 bg-blue-600 text-white rounded-md flex items-center space-x-2 hover:bg-blue-700 transition-colors" onClick={handleCreateWorkflow} data-id="element-1607">
            <Plus className="h-4 w-4" data-id="element-1608" />
            <span data-id="element-1609">Create Workflow</span>
          </button>
        </div>
      </div>

      {viewMode === 'list' ? <>
          <div className="flex items-center space-x-6 border-b border-gray-200 mb-6" data-id="element-1610">
            <button className={`py-3 px-1 ${activeTab === 'active' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('active')} data-id="element-1611">
              Active Workflows
            </button>
            <button className={`py-3 px-1 ${activeTab === 'completed' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('completed')} data-id="element-1612">
              Completed
            </button>
            <button className={`py-3 px-1 ${activeTab === 'templates' ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600'}`} onClick={() => setActiveTab('templates')} data-id="element-1613">
              Templates
            </button>
          </div>
          <div className="flex justify-between items-center mb-6" data-id="element-1614">
            <div className="relative w-96" data-id="element-1615">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" data-id="element-1616" />
              <input type="text" placeholder="Search workflows..." className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full" data-id="element-1617" />
            </div>
            <div className="flex items-center space-x-4" data-id="element-1618">
              <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700" data-id="element-1619">
                <Filter className="h-4 w-4" data-id="element-1620" />
                <span data-id="element-1621">Filters</span>
                <ChevronDown className="h-4 w-4" data-id="element-1622" />
              </button>
              <button className="flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-md text-gray-700" data-id="element-1623">
                <Clock className="h-4 w-4" data-id="element-1624" />
                <span data-id="element-1625">Last modified</span>
                <ChevronDown className="h-4 w-4" data-id="element-1626" />
              </button>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-6" data-id="element-1627">
            {localWorkflows.filter(w => activeTab === 'active' ? w.status !== 'Completed' : w.status === 'Completed').map(workflow => <WorkflowCard key={workflow.id} workflow={workflow} onEdit={() => handleEditWorkflow(workflow)} onView={() => handleViewWorkflow(workflow)} data-id="element-1628" />)}
          </div>
        </> : <WorkflowAnalytics workflows={localWorkflows} data-id="element-1629" />}

      {/* Workflow Creation/Editing Modal */}
      <WorkflowCreationModal isOpen={isWorkflowModalOpen} onClose={handleCloseWorkflowModal} departments={departments} existingWorkflow={workflowToEdit} data-id="element-1630" />

      {/* Workflow Viewer Modal */}
      {selectedWorkflow && <WorkflowViewerModal workflow={selectedWorkflow} onClose={handleCloseViewer} onEdit={handleEditWorkflow} data-id="element-1631" />}
    </div>;
};
const WorkflowCard = ({
  workflow,
  onEdit,
  onView
}) => {
  return <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-1632">
      <div className="p-6" data-id="element-1633">
        <div className="flex justify-between items-start mb-4" data-id="element-1634">
          <div data-id="element-1635">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-1636">
              {workflow.name}
            </h3>
            <p className="text-sm text-gray-500 mt-1" data-id="element-1637">{workflow.description}</p>
          </div>
          <div className="flex items-center" data-id="element-1638">
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusStyles(workflow.status)}`} data-id="element-1639">
              {workflow.status}
            </span>
            <div className="relative ml-4" data-id="element-1640">
              <button className="text-gray-400 hover:text-gray-600" data-id="element-1641">
                <MoreVertical className="h-5 w-5" data-id="element-1642" />
              </button>
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-2 text-sm text-gray-500 mb-6" data-id="element-1643">
          <Clock className="h-4 w-4" data-id="element-1644" />
          <span data-id="element-1645">Started {workflow.startDate}</span>
          <span className="mx-2" data-id="element-1646">•</span>
          <span data-id="element-1647">
            {workflow.dueDate ? `Due ${workflow.dueDate}` : 'No due date'}
          </span>
        </div>
        <div className="flex items-center mb-6" data-id="element-1648">
          <div className="flex -space-x-2" data-id="element-1649">
            {workflow.participants.map((participant, index) => <div key={index} className="h-8 w-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-xs font-medium text-gray-600" title={participant.name} data-id="element-1650">
                {participant.initials}
              </div>)}
            <button className="h-8 w-8 rounded-full bg-gray-100 border-2 border-white flex items-center justify-center ml-1" data-id="element-1651">
              <UserPlus className="h-4 w-4 text-gray-600" data-id="element-1652" />
            </button>
          </div>
          <div className="ml-auto flex items-center space-x-4" data-id="element-1653">
            <button className="text-sm text-gray-600 flex items-center space-x-1" onClick={() => onEdit(workflow)} data-id="element-1654">
              <Settings className="h-4 w-4" data-id="element-1655" />
              <span data-id="element-1656">Configure</span>
            </button>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 transition-colors flex items-center space-x-1" onClick={() => onView(workflow)} data-id="element-1657">
              <Eye className="h-4 w-4" data-id="element-1658" />
              <span data-id="element-1659">View Details</span>
            </button>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-4" data-id="element-1660">
          <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-1661">
            Workflow Progress
          </h4>
          <div className="flex items-center space-x-4" data-id="element-1662">
            {workflow.steps.map((step, index) => <Fragment key={index} data-id="element-1663">
                <div className="flex flex-col items-center" data-id="element-1664">
                  <div className={`h-10 w-10 rounded-full flex items-center justify-center ${getStepStatusStyles(step.status)}`} data-id="element-1665">
                    {getStepStatusIcon(step.status)}
                  </div>
                  <span className="text-xs text-gray-600 mt-1 text-center max-w-[80px] truncate" data-id="element-1666">
                    {step.name}
                  </span>
                </div>
                {index < workflow.steps.length - 1 && <ArrowRight className="h-4 w-4 text-gray-400" data-id="element-1667" />}
              </Fragment>)}
          </div>
        </div>
      </div>
    </div>;
};
const getStatusStyles = status => {
  switch (status) {
    case 'In Progress':
      return 'bg-blue-100 text-blue-800';
    case 'Pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'Completed':
      return 'bg-green-100 text-green-800';
    case 'Rejected':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
const getStepStatusStyles = status => {
  switch (status) {
    case 'completed':
      return 'bg-green-100 text-green-600';
    case 'current':
      return 'bg-blue-100 text-blue-600';
    case 'pending':
      return 'bg-gray-100 text-gray-600';
    case 'rejected':
      return 'bg-red-100 text-red-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};
const getStepStatusIcon = status => {
  switch (status) {
    case 'completed':
      return <CheckCircle className="h-5 w-5" data-id="element-1668" />;
    case 'current':
      return <Clock className="h-5 w-5" data-id="element-1669" />;
    case 'pending':
      return <div className="h-3 w-3 rounded-full bg-gray-400" data-id="element-1670"></div>;
    case 'rejected':
      return <X className="h-5 w-5" data-id="element-1671" />;
    default:
      return <div className="h-3 w-3 rounded-full bg-gray-400" data-id="element-1672"></div>;
  }
};
// Sample data
const workflows = [{
  id: 1,
  name: 'Annual Budget Approval',
  description: 'Workflow for approving the annual budget for the General Manager Office',
  status: 'In Progress',
  startDate: 'Aug 15, 2023',
  dueDate: 'Sep 30, 2023',
  participants: [{
    name: 'Jasim Alawadhi',
    initials: 'JA'
  }, {
    name: 'Fatima Ahmed',
    initials: 'FA'
  }, {
    name: 'Mohammed Ali',
    initials: 'MA'
  }],
  steps: [{
    name: 'Document Creation',
    status: 'completed'
  }, {
    name: 'Department Review',
    status: 'completed'
  }, {
    name: 'Finance Approval',
    status: 'current'
  }, {
    name: 'GM Approval',
    status: 'pending'
  }, {
    name: 'Final Archive',
    status: 'pending'
  }]
}, {
  id: 2,
  name: 'Employee Onboarding Process',
  description: 'Standard workflow for onboarding new employees',
  status: 'Pending',
  startDate: 'Aug 20, 2023',
  dueDate: 'Sep 10, 2023',
  participants: [{
    name: 'Jasim Alawadhi',
    initials: 'JA'
  }, {
    name: 'Hiba Ali',
    initials: 'HA'
  }],
  steps: [{
    name: 'HR Initiation',
    status: 'completed'
  }, {
    name: 'Document Collection',
    status: 'current'
  }, {
    name: 'IT Setup',
    status: 'pending'
  }, {
    name: 'Training Schedule',
    status: 'pending'
  }]
}, {
  id: 3,
  name: 'Project Proposal Review',
  description: 'Review process for new project proposals',
  status: 'Completed',
  startDate: 'Jul 10, 2023',
  dueDate: 'Aug 5, 2023',
  participants: [{
    name: 'Jasim Alawadhi',
    initials: 'JA'
  }, {
    name: 'Noura Abdullah',
    initials: 'NA'
  }, {
    name: 'Ahmed Khalid',
    initials: 'AK'
  }],
  steps: [{
    name: 'Proposal Submission',
    status: 'completed'
  }, {
    name: 'Initial Review',
    status: 'completed'
  }, {
    name: 'Department Feedback',
    status: 'completed'
  }, {
    name: 'Final Decision',
    status: 'completed'
  }]
}];